<template>
  <div class="dialog-wrap">
    <el-dialog title="课程讲义添加"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="880px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="讲义名称"
                      prop="name">
          <el-input v-model="dataForm.name"
                    placeholder="请输入讲义名称"></el-input>
        </el-form-item>
        <el-form-item label="讲义描述"
                      prop="description">
          <el-input v-model="dataForm.description"
                    placeholder="请输入讲义描述"></el-input>
        </el-form-item>
        <el-form-item label="排序值"
                      prop="sort">
          <el-input v-model="dataForm.sort"
                    placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="资源类型"
                      prop="type">
          <!-- <el-radio-group v-model="dataForm.type">
            <el-radio :label="1">图文资料</el-radio>
            <el-radio :label="2">PDF资料</el-radio>
          </el-radio-group> -->
          <div style="display: flex; justify-content: space-between">
            <div class="box-type"
                 v-for="(item, index) in dataTypeList"
                 :key="index"
                 @click="handleMaterialTypeChange(item.type)">
              <img :src="item.img"
                   alt="" />
              <div>{{ item.name }}</div>
              <img v-if="materialType == item.type"
                   class="box-boder"
                   :src="require('/src/assets/img/box-border.png')"
                   alt="" />
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <div class="resource-item"
               v-if="materialType == 1">
            <UEeditor :setDataStr="richText"
                      @change="initDtaForm" />
            <!--   <VueEditor
              :content="richText"
              @change="handleRichTextChange"
              placeholder="输入图文资料"
            /> -->
          </div>
          <div class="resource-item"
               v-if="materialType == 2">
            <!-- ,.xlsx, .xls -->
            <el-upload accept=".pdf"
                       class="uploader"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button><span style="margin-left: 10px">只能上传pdf文件</span>
            </el-upload>
            <!-- <el-upload
              class="uploader"
              :action="fileUploadPrivateUrl"
              :headers="uploadHeaders"
              :show-file-list="true"
              :file-list="fileList"
              :before-upload="handleBeforeUpload"
              :on-success="handleUploadSuccess"
            >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-upload2"
                plain
              >点击上传</el-button>
            </el-upload>
            <p class="tip">支持扩展名：.pdf</p>
            <div
              class="resource-box"
              v-if="resource.url"
            >
              <a
                :href="resource.url"
                target="_blank"
              >{{resource.name}}</a>
            </div> -->
          </div>
          <div class="resource-item"
               v-if="materialType == 3">
            <el-upload class="uploader"
                       accept=".mp4,.mkv,.mov,.mpeg,.3gp"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left: 10px">只能上传mp4，mkv，mov，mpeg，3gp文件</span>
            </el-upload>
          </div>

          <div class="resource-item"
               v-if="materialType == 4">
            <el-upload class="uploader"
                       accept=".doc,.docx"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left: 10px">只能上传doc，docx文件</span>
            </el-upload>
          </div>

          <div class="resource-item"
               v-if="materialType == 5">
            <el-upload class="uploader"
                       accept=".mp3,.wav,.cd,.aac,.aiff,.oog"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left: 10px">只能上传mp3，wav，cd，aac，aiff，oog文件</span>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="支持下载："
                      prop="support_download_status"
                      v-if="[2,4].includes(materialType)">
          <el-switch v-model="support_download_status"></el-switch>
          <span style="color: #999999; margin-left: 11px">
            开启后学员可以自行下载该资料
          </span>
        </el-form-item>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'
import { randomTimeNumber, getFileExtendingName } from '@/utils/helper'
import { fileUploadPrivateUrl, uploadHeaders } from '@/config/index'
import { courseResourceCreate } from '@/api/course'
import { uploadFileToken, resourceCreate } from '@/api/common'
import UEeditor from '@/components/UEeditor'

export default {
  components: {
    VueEditor,
    UEeditor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionsUrl: '',
      support_download_status: false,
      materialType: 1,
      dialogVisible: this.visible,
      dataForm: {},
      richText: '',
      resource: {},
      fileList: [],
      fileUploadPrivateUrl: fileUploadPrivateUrl(),
      uploadHeaders: uploadHeaders(),
      dataTypeList: [
        {
          name: '图文资料',
          img: require('/src/assets/img/image.png'),
          type: 1,
        },
        {
          name: 'PDF资料',
          img: require('/src/assets/img/PDF.png'),
          type: 2,
        },
        {
          name: 'Word资料',
          img: require('/src/assets/img/word.png'),
          type: 4,
        },
        {
          name: '视频资料',
          img: require('/src/assets/img/video.png'),
          type: 3,
        },
        {
          name: '音频资料',
          img: require('/src/assets/img/musci.png'),
          type: 5,
        },
      ],
      rules: {
        name: [{ required: true, message: '请输入院校名称', trigger: 'blur' }],
        // type: [
        //   { required: true, message: "请选择资源类型 ", trigger: "change" },
        // ],
        sort: [
          { required: true, message: '请输入排序值，纯数字', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dataForm = {}
      this.fileList = []
      this.materialType = 1
      this.richText = ''
      this.dialogVisible = val
      this.support_download_status = false
    },
  },
  methods: {
    handleMaterialTypeChange(type) {
      this.richText = ''
      this.fileList = []
      this.materialType = type
    },

    // 文件上传前处理
    handleBeforeUpload(file) {
      return true
    },
    // 文件上传成功回调
    handleUploadSuccess(res, file) {
      this.fileList = [res.data]
      //  console.log('this.fileList:', this.fileList)
      if (res.code == 0 && res.data) {
        const values = {
          name: res.data.name,
          key: res.data.url + '*',
          url: res.data.url + '*',
          size: file.size,
          type: 1,
        }
        if (file.raw && file.raw.type) {
          values['mime_type'] = file.raw.type
        }
        resourceCreate(values).then((res2) => {
          this.resource = res2
          // this.fileList = []
        })
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadRemove() {
      this.fileList = []
    },
    // 图文资料
    handleRichTextChange(editor) {
      this.richText = editor.html
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            product_id: this.$route.params.courseId,
            type: this.materialType,
          })
          params.rich_text = this.richText
          if (params.type != 1 && this.resource && this.resource.id) {
            params.resource_id = this.resource.id
          }
          if (params.type == 1 && !params.rich_text) {
            this.$message.error('图文资料内容不能为空')
            return
          } else if (params.type == 2 && !this.fileList.length) {
            this.$message.error('PDF资料暂未上传')
            return
          } else if (params.type == 4 && !this.fileList.length) {
            this.$message.error('Word资料暂未上传')
            return
          } else if (params.type == 3 && !this.fileList.length) {
            this.$message.error('视频资料暂未上传')
            return
          } else if (params.type == 5 && !this.fileList.length) {
            this.$message.error('音频资料暂未上传')
            return
          }
          if ([2, 4].includes(this.materialType)) {
            params.support_download_status = this.support_download_status
              ? 1
              : 0
          } else {
            params.support_download_status = 0
          }

          courseResourceCreate(params)
            .then((res) => {
              this.$message.success(`添加成功`)
              this.$refs['dataForm'].resetFields()
              this.richText = ''
              this.resource = {}

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    initDtaForm(e) {
      this.richText = e
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }

  .resource-item {
    display: flex;
    align-items: center;

    .tip {
      font-size: 12px;
      color: #999;
      margin-left: 10px;
    }
  }
  .resource-box {
    margin-left: 20px;

    a {
      color: #409eff;
      text-decoration: underline;
    }
  }
}

.box-type {
  cursor: pointer;
  width: 140px;
  height: 72px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  & > img {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
  // margin-right: 16px;
  position: relative;
  .box-boder {
    width: 140px !important;
    height: 72px !important;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.box-type:nth-of-type(5) {
  img {
    width: 20px;
    height: 24px;
  }
}
</style>
